module.exports = __webpack_public_path__ + "img/icone1.8e3d6da2.png";